/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/** The GM mark - outline, letters and underline as one shape - on the GMDS 34-unit grid. */
const GM_MARK =
  'M34 4.84808C34 1.9086 32.0946 0 29.1503 0H4.84969C1.90938 0 0 1.90462 0 4.84808V29.1519C0 32.0914 1.90538 34 4.84969 34H29.1503C32.0906 34 34 32.0954 34 29.1519V4.84808ZM28.9244 31.8435H5.07719C3.14812 31.8427 2.15812 30.8519 2.15812 28.926V5.07404C2.15812 3.14812 3.14812 2.15731 5.07562 2.15731H28.9228C30.8471 2.15731 31.8404 3.14812 31.8404 5.07404V28.926C31.8419 30.8519 30.8519 31.8435 28.9244 31.8435ZM27.7037 11.5836V20.5936H25.223V11.9456C25.223 11.3467 24.8294 10.9587 24.2463 10.9587H22.8453V20.5936H20.3677V10.9587H17.9893V20.5936H15.5125V8.80846H24.9247C26.6538 8.80846 27.7037 9.87969 27.7037 11.5836ZM13.6315 8.80846V21.0721C13.6315 22.5148 12.9869 25.1915 8.77625 25.1915H7.73422V23.0161H8.77697C10.4298 22.9854 11.12 22.2881 11.1484 21.0879V20.5936H9.07531C7.42813 20.5936 6.29625 19.4831 6.29625 17.8185V11.5836C6.29625 9.92454 7.39812 8.80846 9.07219 8.80846H13.6315ZM11.1539 10.9587H9.75937C9.17375 10.9587 8.77697 11.3687 8.77697 11.937V17.4376C8.77697 18.0318 9.19503 18.4403 9.78678 18.4403H11.1539V10.9587ZM15.5125 25.1923H27.7037V23.0161H15.5125V25.1923Z';

/**
 * The GM mark, drawn inline so it never waits on a file. Black and white: painted in the default
 * text colour (`--color-foreground`), so it is black on the light theme and white on the dark one,
 * never the brand blue.
 *
 * `decorative` hides it from assistive technology, for places where a name beside it (or a live
 * region around it) already says what it would.
 */
export function GmLogo({
  size = 34,
  className,
  decorative = false,
}: {
  size?: number;
  className?: string;
  decorative?: boolean;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 34"
      className={className}
      role={decorative ? undefined : 'img'}
      aria-label={decorative ? undefined : 'General Motors'}
      aria-hidden={decorative || undefined}
      focusable="false"
    >
      <path d={GM_MARK} fill="var(--color-foreground)" />
    </svg>
  );
}
